import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  searchIcon: {
    color: theme.palette.placeholder.main,
  },
  clearButton: {
    padding: 0,
    color: theme.palette.placeholder.main,
  },
  searchInputRoot: {
    color: theme.palette.contrastText.main,
    width: "100%",
    height: 44,
    background: theme.palette.otherElementsBackground.main,
    border: `1px solid ${theme.palette.separator.main}`,
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0, 2),
    borderRadius: theme.spacing(7),
  },
  searchInputFocused: {
    background: theme.palette.chipBackground.main,
    borderColor: theme.palette.primary.main,
    "& $searchIcon": {
      color: theme.palette.primary.main,
    },
  },
  searchInputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: theme.spacing(1),
    transition: theme.transitions.create("width"),
    width: "100% !important",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
    "&::placeholder": {
      color: theme.palette.placeholder.main,
      opacity: 1,
    },
  },
}));
